import React from 'react';
import { FaLinkedin, FaTwitter } from 'react-icons/fa';

const Lifeatinovaantage = () => {
  return (
    <>
      {/* Devan Bala */}
      <div style={cardStyle}>
        <img src='https://inovaantage.com/wp-content/uploads/2024/02/Skype_Picture_2021_04_23T12_50_38_170Z-800x800-1.jpeg' alt='np pic11' style={imageStyle} />
        <h1>Devan Bala</h1>
        <h3>Life at Inovaantage</h3>
        <p>
          My name is Devan Balasubramanian. Im a BSc Software Engineering 1st class graduate. Im working in Inovaantage less than a year now. But i have learned a lot in this period along with this Inovaantage Family. Anytime any doubt, the team will be ready to help me. When im nervous to present something, the team always cheer up me. I would like to thank the whole Inovaantage Family for letting me to be part of this wonderful family. In addition, I need to thank Dr Sukanta and Mr Sunu for always got my back. I have learned to work under pressure, handle clients, present to clients, and etc. Once again thank you so much for having me in this company. Looking forward to work in many other projects in the future.
          {/* shortened for brevity */}
        </p>
        <div style={iconContainer}>
          <FaLinkedin style={iconStyle} />
          <FaTwitter style={iconStyle} />
        </div>
      </div>

      {/* Dr. Barnali Basu */}
      <div style={cardStyle}>
        <img src='https://inovaantage.com/wp-content/uploads/2024/02/Skype_Picture_2021_04_23T12_50_42_089Z-1-800x1067-1.jpeg' alt='np pic11' style={imageStyle} />
        <h1>Dr. Barnali Basu</h1>
        <h3>Life at Inovaantage</h3>
        <p>
          After a long professional experience in India, I arrived in Singapore in the mid of 2018. Within a couple of months, I felt like I was not making good use of my skills and passions. I felt stuck and wondered where to turn next. That’s when I came across an opportunity at Inovaantage. Moving to a new country truly changed the trajectory of my career & life. It gave me confidence in my strengths. I realised what truly gives me joy. So, I began to benefit from everything around me to grow continually. At Inovaantage, I am exploring different areas: project management, business analysis, and sales. I have also got the chance to assist with the design and implementation of different IT processes and tools, which enable our customers to improve the way they operate and increase the quality of their services. Therefore, working at Inovaantage represents the translation of all the knowledge I have acquired till now into practice. I consider this to be a significant step forward in my personal and professional development. In addition to this, I feel that Inovaantage creates the perfect conditions for innovation and creativity. It provides me with international work experience, opportunities, and networks that take my career to the next level. And this is something that I am really excited about!


          {/* shortened for brevity */}
        </p>
        <div style={iconContainer}>
          <FaLinkedin style={iconStyle} />
          <FaTwitter style={iconStyle} />
        </div>
      </div>
    </>
  );
};

// Optional inline styles for quick layout
const cardStyle = {
  padding: '1.5rem',
  margin: '1rem auto',
  maxWidth: '800px',
  backgroundColor: '#f9f9f9',
  borderRadius: '12px',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)'
};

const imageStyle = {
  width: '100%',
  maxWidth: '300px',
  borderRadius: '8px',
  marginBottom: '1rem'
};

const iconContainer = {
  display: 'flex',
  gap: '1rem',
  marginTop: '1rem'
};

const iconStyle = {
  fontSize: '1.5rem',
  color: '#0077b5', // LinkedIn blue (can customize)
  cursor: 'pointer'
};

export default Lifeatinovaantage;
